// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactSyntaxHighlighter from "react-syntax-highlighter";
import OneMonokaiJson from "../styles/code/oneMonokai.json";

var codeStyleOneMonokai = OneMonokaiJson;

function s(prim) {
  return prim;
}

function codeProcessor(param) {
  var children = param.children;
  var cl = Belt_Option.getWithDefault(param.className, "");
  var genericCode = JsxRuntime.jsx("code", {
        children: children,
        className: cl
      });
  var langLabel = Js_string.match_(/language-(\w+)/, cl);
  if (langLabel === undefined) {
    return genericCode;
  }
  var label = Belt_Option.getWithDefault(Belt_Option.getWithDefault(Belt_Array.get(langLabel, 1), undefined), "txt");
  return JsxRuntime.jsx(ReactSyntaxHighlighter.Prism, {
              children: children,
              language: label,
              style: Caml_option.some(Caml_option.some(codeStyleOneMonokai))
            });
}

function isAudioSource(src) {
  var __x = /\.(mp3|wav|ogg|m4a|flac)(\?.*)?$/i;
  return __x.test(src);
}

function isVideoSource(src) {
  var __x = /\.(mp4|webm|mov)(\?.*)?$/i;
  return __x.test(src);
}

function isWideImage(src) {
  var __x = /-wide\.\w+(\?.*)?$/i;
  return __x.test(src);
}

function unwrap(value, fallback) {
  return Belt_Option.getWithDefault((value == null) ? undefined : Caml_option.some(value), fallback);
}

function imgProcessor(param) {
  var source = Belt_Option.getWithDefault(Caml_option.nullable_to_opt(param.src), "");
  var altText = Belt_Option.getWithDefault(Caml_option.nullable_to_opt(param.alt), "");
  if (isAudioSource(source)) {
    var tmp = altText === "" ? null : JsxRuntime.jsx("span", {
            children: altText,
            className: "article-audio-caption"
          });
    return JsxRuntime.jsxs("span", {
                children: [
                  JsxRuntime.jsx("audio", {
                        controls: true,
                        preload: "metadata",
                        src: source
                      }),
                  tmp
                ],
                className: "article-audio"
              });
  }
  if (isVideoSource(source)) {
    var tmp$1 = altText === "" ? null : JsxRuntime.jsx("span", {
            children: altText,
            className: "article-audio-caption"
          });
    return JsxRuntime.jsxs("span", {
                children: [
                  JsxRuntime.jsx("video", {
                        controls: true,
                        playsInline: true,
                        preload: "metadata",
                        src: source
                      }),
                  tmp$1
                ],
                className: "article-video"
              });
  }
  var className = isWideImage(source) ? "article-img-wide" : "";
  return JsxRuntime.jsx("img", {
              className: className,
              title: Belt_Option.getWithDefault(Caml_option.nullable_to_opt(param.title), ""),
              alt: altText,
              src: source
            });
}

var Internal = {
  codeStyleOneMonokai: codeStyleOneMonokai,
  s: s,
  codeProcessor: codeProcessor,
  isAudioSource: isAudioSource,
  isVideoSource: isVideoSource,
  isWideImage: isWideImage,
  unwrap: unwrap,
  imgProcessor: imgProcessor
};

var renderer = {
  code: codeProcessor,
  img: imgProcessor
};

var $$String;

export {
  $$String ,
  Internal ,
  renderer ,
}
/* codeStyleOneMonokai Not a pure module */
